var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { ViewStateModel } from './view.state.model';
import { ShowPanel, CollapsePanel, ResetView, ShowColumn } from './view.actions';
var initialState = {
    showPanel: false,
    collapsePanel: false,
    showColumn: true
};
var ViewState = /** @class */ (function () {
    function ViewState() {
    }
    /**
     * Selectors
     */
    ViewState.getShowPanel = function (state) {
        return state.showPanel;
    };
    ViewState.getCollapsePanel = function (state) {
        return state.collapsePanel;
    };
    ViewState.getShowColumn = function (state) {
        return state.showColumn;
    };
    /**
     * Actions
     */
    ViewState.prototype.showPanel = function (context, action) {
        context.patchState({
            showPanel: action.show
        });
    };
    ViewState.prototype.showColumn = function (context, action) {
        context.patchState({
            showColumn: action.show
        });
    };
    ViewState.prototype.collapsePanel = function (context, action) {
        context.patchState({
            collapsePanel: action.collapse
        });
    };
    ViewState.prototype.resetView = function (context, action) {
        context.setState(initialState);
    };
    __decorate([
        Action(ShowPanel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ShowPanel]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "showPanel", null);
    __decorate([
        Action(ShowColumn),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ShowColumn]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "showColumn", null);
    __decorate([
        Action(CollapsePanel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CollapsePanel]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "collapsePanel", null);
    __decorate([
        Action(ResetView),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetView]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "resetView", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getShowPanel", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getCollapsePanel", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getShowColumn", null);
    ViewState = __decorate([
        State({
            name: 'view',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [])
    ], ViewState);
    return ViewState;
}());
export { ViewState };
